import React from 'react';
import {styled} from '@mui/material/styles';
import {inMobileApp} from '@practicegenius/pg-ui/src/utils/MobileApp';
import {SupportEmailLink} from '@practicegenius/pg-ui/src/components/SupportEmailLink';
import {LOGIN_ONLY} from '../constants/accessControl';
import {useDoesPracticeHaveAccess} from '../shared/hooks/useDoesPracticeHaveAccess';

const SupportFooter = styled('div')(({theme}) => ({
  margin: '30px 0 45px',
  fontSize: '16px',
  color: theme.palette.secondary.main,
}));

/** @deprecated */
export const LoginSupportFooter = () => {
  const isLoginOnly = useDoesPracticeHaveAccess(LOGIN_ONLY);
  if (inMobileApp) return null;
  const content = isLoginOnly ? null : (
    <>
      Need help logging in?
      <br />
      Contact our Customer Support Team at <SupportEmailLink />
    </>
  );
  return <SupportFooter>{content}</SupportFooter>;
};
